// extracted by mini-css-extract-plugin
export default {"title":"GameCategorySection_title__RifLZ","games":"GameCategorySection_games__ghDok","margin":"GameCategorySection_margin__IM2I9"};